// 약정서 페이지 JavaScript

// 페이지 로드 시 실행
document.addEventListener('DOMContentLoaded', function() {
  // 약정서 페이지 체크 - 핵심 요소가 없으면 실행 안 함
  const customerNameField = document.getElementById('customerName');
  if (!customerNameField) {
    return; // 약정서 페이지가 아니면 종료
  }
  
  loadContractData();
});

// 약정 데이터 로드 (더미 데이터 - 실제로는 세션이나 서버에서 가져옴)
function loadContractData() {
  // admin에서 전달된 데이터를 가져옴 (실제로는 세션 스토리지나 서버에서)
  const dummyData = {
    customerName: '홍길동',
    birthDate: '1990년 12월 34일', // admin에서 직접 받음
    stockAccount: '1234-5678-90',
    interestRate: '연 7.5%',
    loanPeriod: '6개월', // admin에서 직접 받음
    loanAmount: '5,000',
    additionalCost: '5',
    actualAmount: '4,995',
    applicationDate: '2025-11-18', // admin에서 직접 받음
    interestPaymentDate: '매월 1일',
    executionDate: '관리자실행일',
    maturityDate: '대출실행일로 부터 6개월'
  };

  // 데이터 표시
  document.getElementById('customerName').value = dummyData.customerName;
  document.getElementById('birthDate').value = dummyData.birthDate;
  document.getElementById('stockAccount').value = dummyData.stockAccount;
  document.getElementById('interestRate').value = dummyData.interestRate;
  document.getElementById('loanPeriod').value = dummyData.loanPeriod;
  document.getElementById('loanAmount').value = dummyData.loanAmount;
  document.getElementById('additionalCost').value = dummyData.additionalCost;
  document.getElementById('actualAmount').value = dummyData.actualAmount;
  document.getElementById('applicationDate').value = dummyData.applicationDate;
  document.getElementById('interestPaymentDate').value = dummyData.interestPaymentDate;
  document.getElementById('executionDate').value = dummyData.executionDate;
  document.getElementById('maturityDate').value = dummyData.maturityDate;
  
  // 실입금액에만 한글 표시 (loan_form.js의 numberToKorean 사용)
  const actualAmountElement = document.getElementById('actualAmount');
  const actualAmountKoreanElement = document.getElementById('actualAmountKorean');
  
  if (actualAmountElement && actualAmountKoreanElement) {
    const amount = parseInt(actualAmountElement.value.replace(/[^0-9]/g, '')) || 0;
    if (amount > 0) {
      actualAmountKoreanElement.textContent = numberToKorean(amount);
    }
  }
}

// 약정서 출력 (인쇄)
function printContract() {
  window.print();
}

// 계좌운영규칙 페이지로 이동
function goToAccountRules() {
  window.location.href = 'so_c3000.html';
}

// 홈으로 이동
function goToHome() {
  window.location.href = 'index.html';
}

// 전역 함수 노출 (Vue에서 사용 가능)
window.loadContractData = loadContractData;
window.printContract = printContract;
window.goToAccountRules = goToAccountRules;
window.goToHome = goToHome;
